(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.tz-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('tz-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tz-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initEmbers() {
    document.querySelectorAll('.tz-embers').forEach(function (box) {
      if (reduceMotion) return;
      var count = parseInt(box.getAttribute('data-count') || '18', 10);
      for (var i = 0; i < count; i++) {
        var span = document.createElement('span');
        span.className = 'tz-ember';
        var left = Math.random() * 100;
        var delay = Math.random() * 8;
        var duration = 5 + Math.random() * 5;
        var drift = (Math.random() * 80 - 40) + 'px';
        var size = 3 + Math.random() * 4;
        span.style.left = left + '%';
        span.style.width = size + 'px';
        span.style.height = size + 'px';
        span.style.animationDelay = delay + 's';
        span.style.animationDuration = duration + 's';
        span.style.setProperty('--tz-drift', drift);
        box.appendChild(span);
      }
    });
  }

  function initFrostThaw() {
    var wraps = document.querySelectorAll('.tz-frostwrap');
    if (!wraps.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      wraps.forEach(function (w) { w.classList.add('tz-thawed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setTimeout(function () { entry.target.classList.add('tz-thawed'); }, 350);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });
    wraps.forEach(function (w) { io.observe(w); });
  }

  function initGauges() {
    var els = document.querySelectorAll('[data-tz-gauge]');
    if (!els.length) return;
    var run = function (el) {
      var pct = el.getAttribute('data-tz-gauge');
      requestAnimationFrame(function () { el.style.width = pct + '%'; });
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { run(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCompareSlider() {
    document.querySelectorAll('.tz-compare').forEach(function (root) {
      var hot = root.querySelector('.tz-compare__hot');
      var handle = root.querySelector('.tz-compare__handle');
      var grip = root.querySelector('.tz-compare__grip');
      if (!hot || !handle) return;
      var dragging = false;

      function setPct(pct) {
        pct = Math.max(0, Math.min(100, pct));
        hot.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        handle.style.left = pct + '%';
        if (grip) grip.style.left = pct + '%';
      }

      function pointerToPct(clientX) {
        var rect = root.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      function onMove(e) {
        if (!dragging) return;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        setPct(pointerToPct(x));
      }
      function stop() { dragging = false; }

      root.addEventListener('mousedown', function (e) { dragging = true; setPct(pointerToPct(e.clientX)); });
      root.addEventListener('touchstart', function (e) { dragging = true; setPct(pointerToPct(e.touches[0].clientX)); }, { passive: true });
      window.addEventListener('mousemove', onMove);
      window.addEventListener('touchmove', onMove, { passive: true });
      window.addEventListener('mouseup', stop);
      window.addEventListener('touchend', stop);

      if (!reduceMotion) {
        var auto = 50;
        var dir = 1;
        var animId = null;
        var animating = true;
        function autoPlay() {
          if (!animating || dragging) { animId = requestAnimationFrame(autoPlay); return; }
          auto += dir * 0.15;
          if (auto > 72) dir = -1;
          if (auto < 28) dir = 1;
          setPct(auto);
          animId = requestAnimationFrame(autoPlay);
        }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            animating = e.isIntersecting;
            if (e.isIntersecting && !animId) animId = requestAnimationFrame(autoPlay);
          });
        }, { threshold: 0.4 });
        io.observe(root);
        root.addEventListener('mousedown', function () { animating = false; });
      }
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-tz-faq]').forEach(function (root) {
      root.querySelectorAll('[data-tz-faq-item]').forEach(function (item) {
        var btn = item.querySelector('[data-tz-faq-btn]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('tz-faq-open');
          root.querySelectorAll('[data-tz-faq-item]').forEach(function (i) {
            i.classList.remove('tz-faq-open');
            var b = i.querySelector('[data-tz-faq-btn]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) { item.classList.add('tz-faq-open'); btn.setAttribute('aria-expanded', 'true'); }
        });
      });
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-tz-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-tz-gallery-main]');
      var stage = main && main.parentElement;
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-tz-gallery-thumb]'));
      var videoBox = gallery.querySelector('[data-tz-gallery-video]');
      if (!main || !thumbs.length) return;
      var current = 0;
      var video = null;
      var autoResume = true;
      var systemPause = false;

      function hideVideo() {
        if (video) { autoResume = false; video.pause(); }
        if (videoBox) videoBox.hidden = true;
        main.hidden = false;
      }

      function showVideo(thumb) {
        var url = thumb.getAttribute('data-video');
        if (!video || video.getAttribute('data-src') !== url) {
          video = document.createElement('video');
          video.setAttribute('data-src', url);
          video.muted = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.loop = true;
          video.controls = true;
          video.preload = 'metadata';
          video.poster = thumb.getAttribute('data-poster') || '';
          [[thumb.getAttribute('data-video-hls'), 'application/x-mpegURL'], [url, 'video/mp4']].forEach(function (s) {
            if (!s[0]) return;
            var source = document.createElement('source');
            source.src = s[0];
            source.type = s[1];
            video.appendChild(source);
          });
          video.addEventListener('pause', function () {
            // The pause event fires async, so the "paused by us" flag is consumed here rather than reset right after pause().
            if (systemPause) { systemPause = false; return; }
            if (!document.hidden && !videoBox.hidden) autoResume = false;
          });
          video.addEventListener('play', function () { autoResume = true; });
          videoBox.innerHTML = '';
          videoBox.appendChild(video);
        }
        main.hidden = true;
        videoBox.hidden = false;
        autoResume = !reduceMotion;
        if (autoResume) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      }

      function select(i) {
        var n = thumbs.length;
        i = ((i % n) + n) % n;
        var thumb = thumbs[i];
        if (thumb.hasAttribute('data-video') && videoBox) {
          showVideo(thumb);
        } else {
          hideVideo();
          var src = thumb.getAttribute('data-full');
          var srcset = thumb.getAttribute('data-full-srcset');
          if (src) main.src = src;
          if (srcset) main.srcset = srcset;
        }
        thumbs.forEach(function (t) { t.classList.remove('tz-thumb-active'); });
        thumb.classList.add('tz-thumb-active');
        current = i;
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { select(i); });
      });

      // Swipe on the main media (mobile); vertical scrolls are left alone.
      var startX = null, startY = 0;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { startX = null; return; }
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null || thumbs.length < 2) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        select(current + (dx < 0 ? 1 : -1));
      }, { passive: true });

      // Pause the video while it is off screen; resume only if the shopper hadn't paused it.
      if (videoBox && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (!video || videoBox.hidden) return;
          if (entries[0].isIntersecting) {
            if (autoResume) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
          } else if (!video.paused) {
            systemPause = true;
            video.pause();
          }
        }, { threshold: 0.25 }).observe(videoBox);
      }

      // A variant with its own image takes over the stage, even if the video was showing.
      var form = document.querySelector('[data-tz-product-form]');
      if (form) {
        form.addEventListener('tz:variant', function (e) {
          var img = e.detail && e.detail.featured_image;
          if (!img) return;
          hideVideo();
          thumbs.forEach(function (t, i) { if (t.getAttribute('data-full') === img.src) current = i; });
        });
      }
    });
  }

  function initQuantity() {
    document.querySelectorAll('[data-tz-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-tz-qty-input]');
      var minus = wrap.querySelector('[data-tz-qty-minus]');
      var plus = wrap.querySelector('[data-tz-qty-plus]');
      if (!input) return;
      function setVal(v) {
        v = Math.max(1, parseInt(v, 10) || 1);
        input.value = v;
      }
      if (minus) minus.addEventListener('click', function () { setVal(parseInt(input.value, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setVal(parseInt(input.value, 10) + 1); });
      input.addEventListener('change', function () { setVal(input.value); });
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-tz-product-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-tz-variants-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var selects = form.querySelectorAll('[data-tz-option]');
      var idInput = form.querySelector('[data-tz-variant-id]');
      var priceEl = form.querySelector('[data-tz-price]');
      var compareEl = form.querySelector('[data-tz-price-old]');
      var addBtn = form.querySelector('[data-tz-add]');

      function money(cents) {
        var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        try { return (cents / 100).toLocaleString(document.documentElement.lang || 'en', { style: 'currency', currency: currency }); }
        catch (e) { return '$' + (cents / 100).toFixed(2); }
      }

      // Flags option values that have no available variant with the other current choices.
      // A blank value is an option the customer has not chosen yet (size starts blank) and matches anything.
      function markAvailability(values) {
        selects.forEach(function (sel, idx) {
          Array.prototype.forEach.call(sel.options, function (opt) {
            if (opt.value === '') return; // "Select your size" placeholder
            if (!opt.hasAttribute('data-label')) opt.setAttribute('data-label', opt.textContent);
            var ok = variants.some(function (v) {
              return v.available && v.options[idx] === opt.value && v.options.every(function (o, j) { return j === idx || values[j] === '' || o === values[j]; });
            });
            opt.textContent = opt.getAttribute('data-label') + (ok ? '' : ' — Sold out');
            // Keep the current choice selectable so the select never ends up blank; the button shows "Sold out" instead.
            opt.disabled = !ok && opt.value !== sel.value;
          });
          var swatches = sel.previousElementSibling;
          if (swatches && swatches.hasAttribute('data-tz-swatches')) {
            swatches.querySelectorAll('[data-tz-swatch-value]').forEach(function (btn) {
              var val = btn.getAttribute('data-tz-swatch-value');
              var any = variants.some(function (v) { return v.available && v.options[idx] === val; });
              btn.classList.toggle('tz-swatch--soldout', !any);
            });
          }
        });
      }

      function update() {
        var values = Array.prototype.map.call(selects, function (s) { return s.value; });
        markAvailability(values);
        var complete = values.indexOf('') === -1;
        // While the size is blank, any variant of the chosen color stands in for price and image (same price for every size).
        var match = variants.find(function (v) { return v.options.every(function (opt, i) { return values[i] === '' || opt === values[i]; }); });
        if (!match) return;
        if (idInput && complete) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = money(match.compare_at_price);
            compareEl.style.display = '';
          } else { compareEl.style.display = 'none'; }
        }
        if (addBtn) {
          // Without a size the button stays usable: pressing it asks for the size (see the submit check below).
          if (!complete || match.available) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.getAttribute('data-text-available') || addBtn.textContent;
          } else {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute('data-text-soldout') || 'Sold out';
          }
        }
        var detail = complete ? match : Object.assign({}, match, { options: values.filter(Boolean), featured_image: null, incomplete: true });
        form.dispatchEvent(new CustomEvent('tz:variant', { detail: detail }));
        if (match.featured_image) {
          var main = document.querySelector('[data-tz-gallery-main]');
          if (main && main.src !== match.featured_image.src) {
            if (reduceMotion) {
              main.src = match.featured_image.src;
              main.srcset = match.featured_image.srcset || '';
              main.alt = match.featured_image.alt || main.alt;
            } else {
              main.classList.add('tz-img-fading');
              setTimeout(function () {
                main.src = match.featured_image.src;
                main.srcset = match.featured_image.srcset || '';
                main.alt = match.featured_image.alt || main.alt;
                main.classList.remove('tz-img-fading');
              }, 220);
            }
          }
          document.querySelectorAll('[data-tz-gallery-thumb]').forEach(function (thumb) {
            thumb.classList.toggle('tz-thumb-active', thumb.getAttribute('data-full') === match.featured_image.src);
          });
        }
      }

      function updateSwatchUI(select) {
        var wrap = select.previousElementSibling;
        if (!wrap || !wrap.hasAttribute('data-tz-swatches')) return;
        var value = select.value;
        wrap.querySelectorAll('[data-tz-swatch-value]').forEach(function (btn) {
          btn.classList.toggle('tz-swatch--active', btn.getAttribute('data-tz-swatch-value') === value);
        });
        var label = wrap.parentElement.querySelector('[data-tz-swatch-label]');
        if (label) label.textContent = ': ' + value;
      }

      var formEl = form.querySelector('form');
      var addErr = form.querySelector('[data-tz-add-error]');

      function blankSelect() {
        return Array.prototype.find.call(selects, function (s) { return s.value === ''; });
      }

      // Registered before initAjaxProductForm, so stopImmediatePropagation keeps the add-to-cart from running.
      if (formEl) formEl.addEventListener('submit', function (e) {
        var blank = blankSelect();
        if (!blank) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        blank.classList.add('tz-prod__select--error');
        var msg = blank.parentElement.querySelector('[data-tz-option-error]') || addErr;
        if (msg) { msg.textContent = blank.getAttribute('data-required-msg') || 'Please choose an option.'; msg.hidden = false; }
        blank.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        blank.focus({ preventScroll: true });
      });

      selects.forEach(function (s) {
        s.addEventListener('change', function () {
          if (s.value !== '') {
            s.classList.remove('tz-prod__select--error');
            var msg = s.parentElement.querySelector('[data-tz-option-error]');
            if (msg) msg.hidden = true;
          }
          if (addErr && !blankSelect()) addErr.hidden = true;
          update();
        });
      });

      form.querySelectorAll('[data-tz-swatches]').forEach(function (wrap) {
        var select = wrap.nextElementSibling;
        if (!select || select.tagName !== 'SELECT') return;
        wrap.querySelectorAll('[data-tz-swatch-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var value = btn.getAttribute('data-tz-swatch-value');
            if (select.value === value) return;
            select.value = value;
            updateSwatchUI(select);
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      });

      update();
    });
  }

  // Uses what the store already has: Shopify customer events (web pixels) and a dataLayer if one exists.
  function tzTrack(name, data) {
    data = data || {};
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data);
    } catch (e) {}
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, data));
  }

  function tzCartDrawer() { return document.querySelector('cart-drawer'); }

  // Adds to cart and asks Shopify to render the drawer sections in the same response (same contract as Dawn's product-form).
  function tzAddToCart(formData) {
    var drawer = tzCartDrawer();
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw res;
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
        return res;
      });
  }

  function tzErrorText(res) {
    return (res && (res.description || res.message)) || 'Something went wrong. Please try again.';
  }

  function initAjaxProductForm() {
    document.querySelectorAll('[data-tz-product-form]').forEach(function (wrap) {
      var form = wrap.querySelector('form');
      var btn = wrap.querySelector('[data-tz-add]');
      var err = wrap.querySelector('[data-tz-add-error]');
      if (!form || !btn) return;
      form.addEventListener('submit', function (e) {
        // Without the drawer (cart type set to page/notification) keep the classic POST to /cart.
        if (!tzCartDrawer() || !window.fetch || !window.FormData) return;
        e.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return;
        if (err) err.hidden = true;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        tzAddToCart(new FormData(form))
          .catch(function (res) {
            if (err) { err.textContent = tzErrorText(res); err.hidden = false; }
          })
          .then(function () {
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
          });
      });
    });
  }

  // Second-unit upsell in the cart drawer. The drawer HTML is replaced on every cart change,
  // so everything is delegated from document and each freshly rendered block is synced once.
  function initDrawerUpsell() {
    function variantsOf(root) {
      try { return JSON.parse(root.querySelector('[data-tz-up-variants]').textContent); } catch (e) { return []; }
    }
    function selectsOf(root) { return Array.prototype.slice.call(root.querySelectorAll('[data-tz-up-option]')); }
    function valuesOf(root) { return selectsOf(root).map(function (s) { return s.value; }); }
    function findVariant(variants, values) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return values[i] === undefined || o === values[i]; }); });
    }

    function sync(root, changedIndex) {
      var variants = variantsOf(root);
      var selects = selectsOf(root);
      var values = valuesOf(root);
      var match = findVariant(variants, values);
      // Changing color to one where the chosen size is sold out: jump to the first size still in stock.
      if (changedIndex !== undefined && (!match || !match.available)) {
        var alt = variants.find(function (v) { return v.available && v.options[changedIndex] === values[changedIndex]; });
        if (alt) {
          selects.forEach(function (s, i) { s.value = alt.options[i]; });
          values = valuesOf(root);
          match = alt;
        }
      }
      selects.forEach(function (sel, idx) {
        Array.prototype.forEach.call(sel.options, function (opt) {
          var ok = variants.some(function (v) {
            return v.available && v.options[idx] === opt.value && v.options.every(function (o, j) { return j === idx || o === values[j]; });
          });
          opt.disabled = !ok;
          opt.textContent = opt.value + (ok ? '' : ' — sold out');
        });
      });
      var btn = root.querySelector('[data-tz-up-add]');
      var available = !!(match && match.available);
      btn.disabled = !available;
      root.setAttribute('data-variant-id', available ? match.id : '');
      if (match) {
        var pct = parseInt(root.getAttribute('data-pct'), 10) || 0;
        var save = Math.floor(match.price * pct / 100);
        var set = function (sel, text) { root.querySelectorAll(sel).forEach(function (el) { el.textContent = text; }); };
        set('[data-tz-up-was]', tzMoney(match.price));
        set('[data-tz-up-now], [data-tz-up-now-inline]', tzMoney(match.price - save));
        set('[data-tz-up-save]', tzMoney(save));
      }
    }

    function payload(root, extra) {
      return Object.assign({
        product_id: root.getAttribute('data-product-id'),
        variant_id: root.getAttribute('data-variant-id'),
        offer_percent: parseInt(root.getAttribute('data-pct'), 10) || 0,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      }, extra || {});
    }

    var viewObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        viewObserver.unobserve(entry.target);
        tzTrack('second_jacket_upsell_view', payload(entry.target));
      });
    }, { threshold: 0.5 }) : null;

    function prepare() {
      document.querySelectorAll('[data-tz-upsell]:not([data-tz-ready])').forEach(function (root) {
        root.setAttribute('data-tz-ready', '');
        sync(root);
        if (viewObserver) viewObserver.observe(root);
      });
    }

    document.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-tz-up-option]');
      if (!sel) return;
      sync(sel.closest('[data-tz-upsell]'), parseInt(sel.getAttribute('data-tz-up-option'), 10));
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-tz-up-add]');
      if (!btn) return;
      var root = btn.closest('[data-tz-upsell]');
      var id = root.getAttribute('data-variant-id');
      var err = root.querySelector('[data-tz-up-error]');
      if (!id || btn.getAttribute('aria-busy') === 'true') return;
      tzTrack('second_jacket_upsell_click', payload(root));
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      if (err) err.hidden = true;
      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', '1');
      tzAddToCart(fd)
        .then(function () { tzTrack('second_jacket_upsell_added', payload(root)); })
        .catch(function (res) {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
          if (err) { err.textContent = tzErrorText(res); err.hidden = false; }
        });
    });

    prepare();
    var drawer = tzCartDrawer();
    if (drawer && 'MutationObserver' in window) new MutationObserver(prepare).observe(drawer, { childList: true, subtree: true });
  }

  function tzMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return (cents / 100).toLocaleString(document.documentElement.lang || 'en', { style: 'currency', currency: currency }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  // Keeps the 1 / 2 unit offer in sync with the selected variant; must mirror the automatic BXGY discount.
  function initOffer() {
    document.querySelectorAll('[data-tz-product-form]').forEach(function (form) {
      var offer = form.querySelector('[data-tz-offer]');
      var qty = form.querySelector('[data-tz-qty-input]');
      if (!offer || !qty) return;
      var pct = parseInt(offer.getAttribute('data-pct'), 10) || 0;
      var radios = offer.querySelectorAll('[data-tz-offer-radio]');
      var sticky = document.querySelector('[data-tz-sticky-price]');
      var price = null;

      function set(sel, text) { var el = offer.querySelector(sel); if (el) el.textContent = text; }

      function render() {
        if (price === null) return;
        // Shopify truncates the discount to the cent, so round the discount down, not the price.
        var second = price - Math.floor(price * pct / 100);
        var total = price + second;
        set('[data-tz-offer-one]', tzMoney(price));
        set('[data-tz-offer-second]', tzMoney(second));
        set('[data-tz-offer-full]', tzMoney(price * 2));
        set('[data-tz-offer-total]', tzMoney(total));
        set('[data-tz-offer-save]', tzMoney(price * 2 - total));
        set('[data-tz-offer-each]', tzMoney(Math.round(total / 2)));
        var two = offer.querySelector('[data-tz-offer-radio]:checked');
        two = two && two.value === '2';
        qty.value = two ? 2 : 1;
        if (sticky) sticky.textContent = two ? tzMoney(total) + ' · 2 ' + (offer.getAttribute('data-plural') || '') : tzMoney(price);
      }

      form.addEventListener('tz:variant', function (e) { price = e.detail.price; render(); });
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          offer.querySelectorAll('.tz-offer__card').forEach(function (c) { c.classList.toggle('tz-offer__card--on', c.contains(r) && r.checked); });
          render();
        });
      });
      var checked = offer.querySelector('[data-tz-offer-radio]:checked');
      if (checked) checked.closest('.tz-offer__card').classList.add('tz-offer__card--on');
    });
  }

  function initSizeFinder() {
    var dialog = document.querySelector('[data-tz-sizefinder]');
    if (!dialog || typeof dialog.showModal !== 'function') {
      // No <dialog> support: fall back to the inline size guide that is already on the page.
      document.querySelectorAll('[data-tz-sizefinder-open]').forEach(function (b) { b.hidden = true; });
      return;
    }
    var opener = null;
    document.addEventListener('click', function (e) {
      var open = e.target.closest && e.target.closest('[data-tz-sizefinder-open]');
      if (open) { opener = open; dialog.showModal(); return; }
      if (e.target.closest && e.target.closest('[data-tz-sizefinder-close]')) { dialog.close(); return; }
      if (e.target === dialog) dialog.close(); // click on the backdrop
    });
    dialog.addEventListener('close', function () { if (opener) opener.focus(); });
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) days--;
    }
    return d;
  }

  function addDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function initEta() {
    document.querySelectorAll('[data-tz-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      var label = el.querySelector('[data-tz-eta-label]');
      if (!min || !max || !label) return;
      var now = new Date();
      var fmt = { month: 'short', day: 'numeric' };
      var lang = document.documentElement.lang || 'en';
      var range = addDays(now, min).toLocaleDateString(lang, fmt) + ' – ' + addDays(now, max).toLocaleDateString(lang, fmt);
      label.textContent = (el.getAttribute('data-text') || '[dates]').replace('[dates]', range);
      el.hidden = false;
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-tz-sticky]');
    var addBtn = document.querySelector('[data-tz-product-form] [data-tz-add]');
    if (!bar || !addBtn || !('IntersectionObserver' in window)) return;
    var stickyBtn = bar.querySelector('[data-tz-sticky-btn]');
    var form = addBtn.closest('[data-tz-product-form]');
    var variantEl = bar.querySelector('[data-tz-sticky-variant]');
    var priceEl = bar.querySelector('[data-tz-sticky-price]');
    var hasOffer = !!form.querySelector('[data-tz-offer]');
    form.addEventListener('tz:variant', function (e) {
      if (variantEl) variantEl.textContent = e.detail.options.join(' / ');
      // With the 1/2 offer, initOffer owns the price (it depends on the chosen quantity).
      if (!hasOffer && priceEl) priceEl.textContent = tzMoney(e.detail.price);
    });
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('tz-sticky--on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyBtn.tabIndex = show ? 0 : -1;
    });
    io.observe(addBtn);
    stickyBtn.addEventListener('click', function () {
      if (addBtn.disabled) {
        addBtn.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      addBtn.click();
    });
    new MutationObserver(function () {
      stickyBtn.disabled = addBtn.disabled;
      stickyBtn.textContent = addBtn.textContent.trim();
    }).observe(addBtn, { attributes: true, childList: true, characterData: true, subtree: true });
  }

  function init() {
    initReveals();
    initEmbers();
    initFrostThaw();
    initGauges();
    initCompareSlider();
    initFaq();
    initGallery();
    initOffer();
    initVariants();
    initQuantity();
    initEta();
    initSticky();
    initAjaxProductForm();
    initDrawerUpsell();
    initSizeFinder();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
